import {MatTooltipModule} from '@angular/material/tooltip';
import {NgModule} from '@angular/core';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import {ResizableModule} from './modules-old/resizable/resizable.module';
import {SaveUserSettingsPageModule} from './modules-old/save-user-settings/save-user-settings.module';
import {SHARED_MODULE_COMPONENTS} from './components';
import {SHARED_MODULE_DIRECTIVE} from './directives';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {SharedIconsModule} from '../shared-icons/shared-icons.module';
import {AgGridAngular} from 'ag-grid-angular';
import {MatButtonModule} from '@angular/material/button';
import {PushPipe} from '@ngrx/component';
import {SharedComponentsModule} from '../../shared/shared-components/shared-components.module';
import {UiComponentsModule} from '../../shared/shared-module-ui/ui-components.module';

@NgModule({
  declarations: [
    ...SHARED_MODULE_COMPONENTS,
    ...SHARED_MODULE_DIRECTIVE,
  ],
  imports: [
    // AgGridAngular?
    CommonModule,
    FormsModule,
    MatTooltipModule,
    ResizableModule,
    SaveUserSettingsPageModule,
    ReactiveFormsModule,
    SharedIconsModule,
    AgGridAngular,
    MatButtonModule,
    PushPipe,
    NgOptimizedImage,
    SharedComponentsModule,
    UiComponentsModule,
  ],
  exports: [
    ResizableModule,
    SaveUserSettingsPageModule, // Is this necessary?
    ...SHARED_MODULE_COMPONENTS,
    ...SHARED_MODULE_DIRECTIVE,
  ],
})
export class SharedModule {
}
